module.exports = __webpack_public_path__ + "gd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/gd.svg
// module id = 558
// module chunks = 0